// Dependencies
import styled, { css } from "styled-components";

// Utils
import { theme } from "config/theme";

type ContainerStyleProps = {
    isDisabled: boolean;
    isOpened: boolean;
};

export const Container = styled.div<ContainerStyleProps>`
    display: inline-block;
    width: 100%;

    .select-input {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        background-color: ${theme.colors.white};
        border: 1px solid ${theme.colors.base[200]};

        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-size: 0.875rem;
        font-weight: 400;

        letter-spacing: 0;
        line-height: 1.428;

        width: 100%;
        padding: 0.675rem 1rem;
        border-radius: 4px;
    }

    .icons-container {
        position: relative;
        display: flex;
        align-items: center;

        .icon {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            width: 1rem;
            height: 1rem;
            margin-left: 0.5rem;

            transition: transform ease-in-out 0.3s;
        }
    }

    ${({ isDisabled }) =>
        !!isDisabled &&
        css`
            .select-input {
                background-color: ${theme.colors.base[100]};
                color: ${theme.colors.base[200]};
                pointer-events: none;
                cursor: not-allowed;
            }
        `}

    ${({ isOpened }) =>
        isOpened &&
        css`
            .icon {
                transform: rotate(180deg);
            }
        `}
`;
